import {useMutation, useQuery} from '@tanstack/react-query';
import {
  deleteComments,
  addDocumentNewComment,
  getCommentsListGrid,
} from '../../api/endpoints/documentApi';
import {
  AddDocumentCommentRequest,
  AddDocumentCommentResponse,
  ICommentsListGridResponse,
  IGetCommentsListGridRequestParams,
} from '../../api/types/document.type';

export const useCommentsListGrid = (
  params: IGetCommentsListGridRequestParams
) => {
  return useQuery<ICommentsListGridResponse, Error>({
    queryKey: ['commentsListGrid', params],
    queryFn: () => getCommentsListGrid(params),
    staleTime: 1000,
  });
};

export const useAddCommentLabel = (
  onSuccess?: (data: AddDocumentCommentResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    AddDocumentCommentResponse,
    Error,
    AddDocumentCommentRequest
  >({
    mutationFn: addDocumentNewComment,
    mutationKey: ['addDocumentNewComment'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDeleteComment = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: deleteComments,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
